import { createSelector } from 'reselect'

export const oidcSelector = createSelector((state) => state.oidc, (oidc) => oidc)